/* eslint-disable zeffo/no-window-storage */
import { DEBUG_KEY } from '@core/debug'

import type { Console } from './fwnConsole'
import { getFwnConsoleInstance } from './helpers'

/**
 * FWN Telemetry Console toggler
 */
export function fwnConsole() {
  let instance: Console | null = null

  const getInstance = async () => {
    if (instance) {
      return instance
    }
    instance = new (await import('./fwnConsole')).Console()
    return instance
  }

  const toggleConsole = async () => {
    const instance = await getInstance()

    if (!instance.isOpen) {
      instance.openConsole()
      try {
        window.localStorage.setItem(DEBUG_KEY, 'true')
      } catch (err) {}
    } else {
      instance.closeConsole()
      try {
        window.localStorage.removeItem(DEBUG_KEY)
      } catch (err) {}
    }

    return instance.isOpen
  }
  toggleConsole.getInstance = getInstance

  return toggleConsole
}

/**
 *
 */
export function attach() {
  if (
    typeof window !== 'undefined' &&
    !Object.prototype.hasOwnProperty.call(window._fwn, 'console')
  ) {
    // Setting up console
    Object.defineProperty(window._fwn, 'console', {
      value: fwnConsole(),
      writable: false,
    })

    if (localStorage.getItem(DEBUG_KEY)) {
      getFwnConsoleInstance().then((instance) => {
        if (!instance.isOpen) {
          instance.openConsole()
        }
      })
    }
  }
}
